var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11431_341170)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.66699 8.00033C6.66699 8.35395 6.80747 8.69309 7.05752 8.94313C7.30757 9.19318 7.6467 9.33366 8.00033 9.33366C8.35395 9.33366 8.69309 9.19318 8.94313 8.94313C9.19318 8.69309 9.33366 8.35395 9.33366 8.00033C9.33366 7.6467 9.19318 7.30757 8.94313 7.05752C8.69309 6.80747 8.35395 6.66699 8.00033 6.66699C7.6467 6.66699 7.30757 6.80747 7.05752 7.05752C6.80747 7.30757 6.66699 7.6467 6.66699 8.00033Z",
    stroke: "#B4B7B8",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 8C12.4 10.6667 10.4 12 8 12C5.6 12 3.6 10.6667 2 8C3.6 5.33333 5.6 4 8 4C10.4 4 12.4 5.33333 14 8Z",
    stroke: "#B4B7B8",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11431_341170"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.fe18c15c4ae53a8a56eeadce311be860.svg";
export { ForwardRef as ReactComponent };